import { Breed } from "../schema/Breed.js";
import { isEnum } from "./enum/isEnum.js";

export const isBreed = isEnum(Breed);
